import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { ActionEventType, ColumnDef } from 'src/app/utils';
import { trunkText } from 'src/app/utils/helpers';
import { translateInstant } from 'src/app/shared/translation-bridge';

const RAW_STATUS_VALUES = ['Actif', 'Activé', 'Inactif', 'Désactivé', 'OUI', 'NON'];

@Component({
  selector: 'app-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.scss'],
})
export class CellComponent implements OnInit {
  @Input() column!: ColumnDef;
  @Input() rowData!: any;
  cellStyle: any;
  buttonStyle: any;
  @Output() actionInvoqueFunctionEvent = new EventEmitter<ActionEventType>();
  @Output() onClickCellValueEvent = new EventEmitter<
    string | number | boolean
  >();

  constructor(@Inject(LOCALE_ID) public locale: string) {}

  ngOnInit(): void {
    const statusColorField = this.column.statusColorField || 'statusColor';
    const statusTextColorField = this.column.statusTextColorField || 'statusTextColor';
    let columnStatusColorProperty = null 
    
    let columnStatusTextColorProperty = null
    if(this.column.type === 'status') {
      columnStatusColorProperty = this.column.statusColorField ? this.column.statusColorField : 'statusColor';
      columnStatusTextColorProperty = this.column.statusTextColorField ? this.column.statusTextColorField : 'statusTextColor';
    }

    this.cellStyle =
      this.column.type === 'status'
        ? {
            ...this.column.cellStyle,
            ...(this.rowData[columnStatusColorProperty!] && {
              'background-color': this.rowData[columnStatusColorProperty!],
            }),
            ...(this.rowData[columnStatusTextColorProperty!] && {
              color: this.rowData[columnStatusTextColorProperty!],
            }),
          }
        : { ...this.column.cellStyle };
  }

  clickCellValueEvent(column: any) {
    if (column.clickable) {
      this.onClickCellValueEvent.emit(
        column.parent
          ? this.rowData[column.parent]
            ? this.rowData[column.parent][column.name]
            : ''
          : this.rowData[column.name]
          ? this.rowData[column.name]
          : ''
      );
    }
  }

  invoqueActionsFunction(value: ActionEventType) {
    this.actionInvoqueFunctionEvent.emit(value);
  }

  setActionButtonColor(rowData: any, action: any, index: number) {
    let styleColor: any = {};
    if (action.isToogleButton && action.actionToogleableIndex === index) {
      const value = action.contextActionStyle;
      if (rowData[action.contextualPropertyToCheck]) {
        styleColor = this.setButtonStyle(value['negatifStyle']);
      } else {
        styleColor = this.setButtonStyle(value['positifStyle']);
      }
    }

    return styleColor;
  }

  getContextualButtonText(rowData: any, action: any) {
    if (rowData[action.contextualPropertyToCheck])
      return action.contextActionText.negatif;
    else return action.contextActionText.positif;
  }

  setButtonStyle(value: any) {
    const styles: any = {};
    styles['background-color'] = value.color;
    styles['border-color'] = value.color;
    styles['min-width'] = '25%';
    return styles;
  }

  callRenderTemplate(value: any) {
    return this.column.renderTemplate(value);
  }

  translateRawStatusValue(value: any): any {
    if (typeof value !== 'string' || !RAW_STATUS_VALUES.includes(value)) return value;
    return translateInstant(`enums.rawStatusLabel.${value}`);
  }

  trunkText(text: string, length: number = 15) {
    return trunkText(text, length);
  }
}
